import type { PlayerHandHistory } from '@acepoker/contract'
import { api } from './api'

export const getHistory = async (
  playerId: string
): Promise<{
  items: PlayerHandHistory[]
  total: number
}> => await api().get(`/api/player/${playerId}/history`).json()
